/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { createListResourceActions, ListResourceReducer, ListResourceState } from '@common/tech-shared';
import { Action, ActionReducerMap } from '@ngrx/store';
import { HISTORIE_FEATURE_KEY, HISTORIE_LIST_PATH } from '../historie.state';

export interface HistorieParentState {
  [HISTORIE_LIST_PATH]: ListResourceState;
}

export const historieReducer: ActionReducerMap<HistorieParentState> = {
  [HISTORIE_LIST_PATH]: historieListResourceReducer,
};

function historieListResourceReducer(state: ListResourceState, action: Action): ListResourceState {
  const resourceReducer: ListResourceReducer = new ListResourceReducer(
    createListResourceActions({ name: HISTORIE_FEATURE_KEY, path: HISTORIE_LIST_PATH }),
  );
  return resourceReducer.reducer(state, action);
}
